import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from "@material-ui/core/styles";
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import Carousel from 'react-material-ui-carousel'

const useStyles = makeStyles( ( theme ) => ( {
    root: {
        // border: '1px solid #f0aa08',
        border: `1px solid ${theme.palette.primary.main}`,
        backgroundColor: '#000000',
        color: `${theme.palette.primary.main}`,
        justifyContent: 'center',
        width: '100%'
    },
    rootNoBorder: {
        backgroundColor: '#000000',
        color: `${theme.palette.primary.main}`,
        justifyContent: 'center',
        width: '100%'
    }
} ) );

const Transition = React.forwardRef( function Transition ( props, ref ) {
    return <Slide direction="up" ref={ref} {...props} />;
} );


export default function NewsModal ( props ) {
    const classes = useStyles();
    const [ open, setOpen ] = useState( false );
    const { openModal, onClose, images, enableClose } = props

    //console.log( images )
    // const handleClickOpen = () => {
    //     setOpen(true);
    // };

    const handleClose = () => {
        setOpen( false );
        onClose();
    };

    useEffect( () => {
        setOpen( openModal )
    }, [ openModal ] )

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            disableBackdropClick={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
        >
            <div style={{ backgroundColor: '#000000' }}>
                <Carousel indicators={true} fullHeightHover={true} swipe={true} animation={"slide"} interval={2500}
                          cycleNavigation={true} stopAutoPlayOnHover={true}>
                    {
                        images.map(
                            ( item ) => (
                                item?.url ?
                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                        <img title={item.message} key={item.id} className={classes.rootNoBorder}
                                             src={item.image_url} alt={item.message}
                                             style={{ maxHeight: '600px', maxWidth: '600px' }}
                                        />
                                    </a>
                                    :
                                    <img title={item.message} key={item.id} className={classes.rootNoBorder}
                                         src={item.image_url} alt={item.message}
                                         style={{ maxHeight: '600px', maxWidth: '600px' }}
                                    />
                            )
                        )
                    }
                </Carousel>
            </div>
            {
                enableClose === false ?
                    ( <Button variant="contained" size={"large"} onClick={() => handleClose()} color="primary"
                              startIcon={<CancelSharpIcon fontSize={"large"}/>}>
                        ปิดหน้านี้
                    </Button> ) :
                    ( <></> )
            }

        </Dialog>
    );
}
